module.exports = __webpack_public_path__ + "static/media/ic-actions-view.54ea31d1.svg";